import useWindowSize from './useWindowSize';

const Large = {
  row12: 1842,
  row6: 892,
  row4: 575,
  row3: 416,
  breakNo: 0
};

const Break1 = {
  row12: 1612,
  row6: 782,
  row4: 505,
  row3: 366,
  breakNo: 1
};

const Break2 = {
  row12: 1392,
  row6: 692,
  row4: 445,
  row3: 326,
  breakNo: 2
};

const Break3 = {
  row12: 1342,
  row6: 652,
  row4: 428,
  row3: 316,
  breakNo: 3
};

const Break4 = {
  row12: 1262,
  row6: 612,
  row4: 401,
  row3: 296,
  breakNo: 4
};

/**
 * @deprecated useIfmsColSizes - get layout sizes in old responsive design. Should not be used any more
 *
 * @export
 * @return {*} 
 */
export default function useIfmsColSizes() {
    const [width, height] = useWindowSize();

    if (width < 1360) {
      return {...Break4, width, height};
    }
    else if (width < 1440) {
      return {...Break3, width, height};
    }
    else if (width < 1680) {
      return {...Break2, width, height};
    }
    else if (width < 1920) {
      return {...Break1, width, height};
    } else {
      return {...Large, width, height};
    }
  }
  